import { API_ROOT } from 'transport-layer'

const authProvider = {
    login: ({ username, password }) => {
        if (!username || !password) {
            return Promise.reject(new Error('Please enter an email and password'))
        }
        const request = new Request(`${API_ROOT}/rpc/login`, {
          method: 'POST',
          body: JSON.stringify({ email: username, password: password }),
          headers: new Headers({ 'Content-Type': 'application/json' })
        })
        return fetch(request)
                .then(response => {
                  const { status } = response
                  if (status === 401 ) {
                    throw new Error(response.statusText)
                  }
                  if (status === 400) {
                    throw new Error('')
                  }
                  return response.json()
                })
                .then(payload => {
                  const { token, me } = payload
                  localStorage.setItem('token', token)
                  localStorage.setItem('role', me.role)
                  localStorage.setItem('id', me.id)
                  localStorage.setItem('username', me.email)
                  localStorage.setItem('fullName', me.fullName)
                  localStorage.setItem('avatar', me.avatar)
                })
    },
    logout: () => {
        localStorage.removeItem('token')
        localStorage.removeItem('role')
        localStorage.removeItem('username')
        localStorage.removeItem('id')
        localStorage.removeItem('fullName')
				localStorage.removeItem('avatar')
        return Promise.resolve()
    },
    checkError: (error) => {
        const status = error.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('token')
            localStorage.removeItem('role')
            localStorage.removeItem('username')
            localStorage.removeItem('id')
            localStorage.removeItem('fullName')
						localStorage.removeItem('avatar')
            return Promise.reject();
        }
        // other error code (404, 500, etc): no need to log out
        return Promise.resolve();
        // if (status === 401) {
        //     localStorage.removeItem('token')
        //     localStorage.removeItem('role')
        //     localStorage.removeItem('username')
        //     return Promise.reject(new Error((json && json.message) || statusText, status))
        //   }
        //   return Promise.resolve()
    },
    checkAuth: () => localStorage.getItem('token') ? Promise.resolve() : Promise.reject(),
    getIdentity: () => {
        try {
            const id = localStorage.getItem('id')
            const fullName = localStorage.getItem('fullName')
            const avatar = localStorage.getItem('avatar')
            return Promise.resolve({
                id,
                fullName,
                avatar
            })
        } catch (error) {
            return Promise.reject(error);
        }
    },
    getPermissions: () => {
        const role = localStorage.getItem('role');
        return role ? Promise.resolve(role) : Promise.reject();
    },
};

export default authProvider;
